import * as actionTypes from '../Register_action.types';

const initialState = {
  loggingIn: false,
  emp_separtion_inputs: [],
  error: null,
  message: '',
};

const Emp_Separation = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_EMP_SEPARATION_REQUEST:
    case actionTypes.UPDATE_EMP_SEPARATION_REQUEST:
    case actionTypes.DELETE_EMP_SEPARATION_REQUEST:
    case actionTypes.UPLOAD_EMP_SEPARATION_REQUEST:
    case actionTypes.MULTIDELETE_EMP_SEPARATION_FAILURE:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.GET_EMP_SEPARATION_SUCCESS:
    case actionTypes.UPDATE_EMP_SEPARATION_SUCCESS:
    case actionTypes.DELETE_EMP_SEPARATION_SUCCESS:
    case actionTypes.UPLOAD_EMP_SEPARATION_SUCCESS:
    case actionTypes.MULTIDELETE_EMP_SEPARATION_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload,
      };

    case actionTypes.GET_OTHER_INPUTS_SUCCESS:
      return {
        ...state,
        loading: false,
        emp_separtion_inputs: action.payload,

      }
    case actionTypes.GET_EMP_SEPARATION_FAILURE:
    case actionTypes.UPDATE_EMP_SEPARATION_FAILURE:
    case actionTypes.DELETE_EMP_SEPARATION_FAILURE:
    case actionTypes.UPLOAD_EMP_SEPARATION_FAILURE:
    case actionTypes.MULTIDELETE_EMP_SEPARATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default Emp_Separation
